import React from 'react'
import Modal from 'react-modal'
import Header from './header'
import Footer from './footer'
import ArrowUp from './../static/images/arrow_up_bold_stroke.svg'
import ArrowRight from './../static/images/arrow_right_bold_stroke.svg'
import ArrowLeft from './../static/images/arrow_left_bold_stroke.svg'

Modal.defaultStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(51, 51, 51, 0.75)'
  },
  content: {
    position: null,
    top: null,
    left: null,
    right: null,
    bottom: null,
    border: null,
    background: null,
    borderRadius: null,
    padding: null
  }
}

class Splash extends React.Component {
  state = {
    showInfo: 0,
    showPopup: false,
    showTop: false
  }

  componentDidMount = () => {
    window.addEventListener('scroll', this.topScroll)
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.topScroll)
  }

  topScroll = () => {
    this.setState(() => ({ showTop: document.body.scrollTop > 20 }))
  }

  handleButton = id => {
    switch (id) {
      case 0:
        window.location.href = '//account.nlg.gr/'
        break

      case 1:
        this.props.history.push('/staff' + this.props.location.search)
        break

      case 2:
        this.props.history.push('/certified' + this.props.location.search)
        break

      case 3:
        this.props.history.push('/user' + this.props.location.search)
        break
    }
  }

  handleInfo = id => {
    if (this.state.showInfo === id) {
      this.setState({
        showInfo: 0
      })
    } else {
      this.setState({
        showInfo: id
      })
    }
  }

  handlePopup = () => {
    this.setState(prevState => ({
      showTop: !prevState.showPopup ? false : document.body.scrollTop > 20,
      showPopup: !prevState.showPopup
    }))
  }

  topClick = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' })
  }

  render = () => {
    let containerClass = this.props.error ? 'error' : ''
    let errors = this.props.error
      ? { generic: this.props.polyglot.t('error.expired') }
      : null

    return (
      <div id='container' className={containerClass}>
        <Header errors={errors} polyglot={this.props.polyglot} />
        <Modal
          isOpen={this.state.showPopup}
          closeTimeoutMS={200}
          onRequestClose={this.handlePopup}
          contentLabel='popup'
        >
          <div id='popup_window'>
            <div id='popup_content'>
              <h1>{this.props.polyglot.t('certified.modal.title')}</h1>
              <p>{this.props.polyglot.t('certified.modal.desc')}</p>
              <button
                onClick={() => {
                  this.handleButton(0)
                }}
              >
                {this.props.polyglot.t('certified.modal.user.registered')}{' '}
                <img src={ArrowRight} className='arrow_right' />
              </button>
              <span className='tab' />
              <span className='tab' />
              <button
                onClick={() => {
                  this.handleButton(2)
                }}
              >
                {this.props.polyglot.t('certified.modal.user.new')}{' '}
                <img src={ArrowRight} className='arrow_right' />
              </button>
            </div>
            <button onClick={this.handlePopup} id='popup_close'>
              <img src={ArrowLeft} className='left' />{' '}
              {this.props.polyglot.t('certified.modal.back')}
            </button>
          </div>
        </Modal>
        <div id='content' className='away_from_logo'>
          <button
            onClick={() => {
              this.handleButton(0)
            }}
            tabIndex='1'
          >
            {this.props.polyglot.t('success.manage.account')}{' '}
            <img src={ArrowRight} className='arrow_right' />
          </button>{' '}
          {this.props.polyglot.t('orRegisterAs')}:
          <div className='reg_roles'>
            <div
              className={
                'reg_role ' + (this.state.showInfo === 2 ? 'active' : '')
              }
            >
              <div
                className='reg_role_title'
                onClick={() => {
                  this.handleInfo(2)
                }}
              >
                <span className='num'>α →</span>{' '}
                {this.props.polyglot.t('certified.title')}
              </div>
              <div className='reg_role_description'>
                {this.props.polyglot.t('certified.desc')}
                <br />
                <br />
                <button onClick={this.handlePopup} id='for_popup' tabIndex='3'>
                  {this.props.polyglot.t('register')}{' '}
                  <img src={ArrowRight} className='arrow_right' />
                </button>
              </div>
            </div>
            <div
              className={
                'reg_role ' + (this.state.showInfo === 3 ? 'active' : '')
              }
            >
              <div
                className='reg_role_title'
                onClick={() => {
                  this.handleInfo(3)
                }}
              >
                <span className='num'>β →</span>{' '}
                {this.props.polyglot.t('user.title')}
              </div>
              <div className='reg_role_description'>
                {this.props.polyglot.t('user.desc')}
                <br />
                <br />
                <button
                  onClick={() => {
                    this.handleButton(3)
                  }}
                  tabIndex='4'
                >
                  {this.props.polyglot.t('register')}{' '}
                  <img src={ArrowRight} className='arrow_right' />
                </button>
              </div>
            </div>
          </div>
        </div>
        <Footer
          privacyPolicy={this.props.config.url.privacyPolicy}
          polyglot={this.props.polyglot}
          changeLang={this.props.changeLang}
        />
        <div
          id='top'
          className={this.state.showTop ? 'visible' : ''}
          onClick={this.topClick}
        >
          <img src={ArrowUp} className='arrow_up' />
        </div>
      </div>
    )
  }
}

export default Splash
